import React, { Component } from 'react';
import { base, firebaseAuth, algoliaKey, alogoliaAccount, logComponentLoad,logDashboardAction } from '../../../config/constants';
import {  Grid } from 'semantic-ui-react'
import * as UiConsts from '../../../config/UiConstants'
import OrderCard from '../../dashBoard/newDashboard/OrderCard';
import * as algoliasearch from 'algoliasearch';
import { getPrintValues, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';

import {getSalesPeople, getDeliveryGuys} from '../../dashBoard/newDashboard/LargeProjects/ApiUtils'
import { getSalesPeopleDropDown, getDeliveryGuysDropdown} from '../../dashBoard/newDashboard/LargeProjects/LargeProjectUtils'


class SingleOrderViewDirect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            imageUrl: '',
            orderNumber: '',
            loadingUser: true,
            loading: false,
            orderFound: '',
            order: [],
            deliveryPeople: [],
            orderNotFound: false,
            status: '',
            designers: [],
            salesPeopleChoices:[],
            deliveryPersonChoices:[],
        }
    }

    componentDidMount() {
        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);
                    getSalesPeople(this.loadSalesPeople);
                    getDeliveryGuys(this.loadDelGuys);
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        });

    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "SingleOrderViewDirect");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser:false
        })

        if(returnObject.isAdmin){

            this.loadOrders(this.props.match.params.order_num);

            this.loadDesigners();
            getPrintValues("statuses", this.loadStatuses);
            getPrintValues("adminemail", this.loadAdmins);
            
        }
    }

    loadDelGuys = (delGuys) => {
       // console.log("getDelguys ++++++++:loadSalesPeopleDropdown");
       // console.log("getdelguys:"+JSON.stringify(delGuys,null,3));
        if(delGuys && delGuys.length > 0){
          //  console.log("getdelguys customer dropdown...")
            this.setState({
                deliveryPersonChoices: getDeliveryGuysDropdown(delGuys)
            })
        }else{
            alert("unable to load delivery people")
        }
    }

    loadSalesPeople = (salesPeople) => {
        console.log("getSales2 ++++++++:loadSalesPeopleDropdown");
        //console.log("getSales22:"+JSON.stringify(salesPeople,null,3));
        if(salesPeople && salesPeople.length > 0){
            console.log("getSales23 customer dropdown...")
            this.setState({
                salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
            })
        }else{
            alert("unable to load salespeople")
        }
    }
    
    loadStatuses = (statuses) => {
        // console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:"+JSON.stringify(statuses, null, 3));
        this.setState({orderStatuses:statuses})
    }

    loadAdmins = (statuses) => {
       // console.log("addx12 ++++++ admins ");
       // console.log("addx121 admins:" + JSON.stringify(statuses, null, 3));
        this.setState({ admins: statuses })
    }

    loadDesigners = () => {
        //console.log("aglx922:-----: loadDesigners calling getDesigners");


        var client = algoliasearch(alogoliaAccount, algoliaKey);
        var index = client.initIndex('printb_values');

        index.search({
            query: '',
            //  facetQuery: '',
            filters: 'grouping:design'
        }).then(content => {
           // console.log("aglx91:" + JSON.stringify(content.hits, null, 3));

            this.setState({
                designers: content.hits
            });


        }).catch(function (err) {
            console.log(err);
            console.log(err.debugData);

        });

    }

    loadOrders = (order_num) => {
        console.log("+++++++: load loadOrders");
        console.log("order_num:" + order_num);

        this.setState({
            loading: true,
            status: order_num
        })

        //SNYC ORDER
        base.syncState('orders', {
            context: this,
            asArray: true,
            state: 'order',
            queries: {
                orderByChild: 'order_num',
                equalTo: parseInt(order_num),
                limitToLast: 1
            },
            then(data) {
                //console.log("dancing done1:" + JSON.stringify(data, null, 2));
                //console.log("dancing done:" + JSON.stringify(this.state.order, null, 2));

                if(this.state.order && this.state.order[0]){
                   //console.log("dancing done2:"+this.state.order[0].order_num);
                    logDashboardAction(this.state.user.email+" loaded order "+this.state.order[0].order_num, this.state.user.email, this.state.order[0].order_num,"SingleOrderViewDirect") 
                }
                

                // if(data == undefined){
                //     alert("order not found in dashboard, check searchNow or archives")
                // }

                this.setState({
                    loading: false
                })
            }
        });
        //parseInt(this.state.orderNumber)
    }

    render() {


        const orderUI = this.state.order.map((order) =>
            <Grid.Column>
                <OrderCard
                    //user={this.state.userFromFirebaseNode}
                    algoliaUser = {this.state.algoliaUser}
                    user={this.state.user}
                    order={order}
                    deliveryPeople={this.state.deliveryPeople}
                    designers={this.state.designers}
                    orderStatuses={this.state.orderStatuses}
                    salesPeopleChoices={this.state.salesPeopleChoices} 
                    deliveryPersonChoices = {this.state.deliveryPersonChoices}/>
            </Grid.Column>
        )

        const loadingImage = this.state.loading === true
            ? <UiConsts.LoadingComponent />
            : <div>
                <Grid stackable columns={3}>
                    {orderUI}
                </Grid>

            </div>

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser.isAdmin
            ? <div>
                <h1>ORDER NUM - {this.props.match.params.order_num}</h1>
                <h1>NUM ORDERS - {this.state.order.length}</h1>


                <br />

                {loadingImage}
                {/* <h2>imageUrls:{this.state.imageUrl}</h2> */}
            </div>
            : <h4>loading error a75</h4>

        return (this.state.loadingUser === true ? <UiConsts.LoadingComponent /> :
            <div>
                
                {wholeUI}

            </div>
        )
    }
}

export default SingleOrderViewDirect;


// WEBPACK FOOTER //
// ./src/components/newSite/SingleOrderView/SingleOrderViewDirect.js